<template>
  <div>
    <el-row>
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px;"
        @submit.native.prevent
      >
        <el-form-item label="音乐名称">
          <el-input
            v-model.trim="formInline.fileName"
            placeholder="请输入音乐名称"
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="onUpload">上传</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-refresh" @click="refresh">刷新</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-table
        :data="tableData"
        style="width: 100%;margin-top:10px;"
        :row-style="tableRowStyle"
        :header-cell-style="tableHeaderColor"
        v-loading="tableLoading"
      >
        <el-table-column prop="oldName" label="序号" min-width="180" align="center">
          <template slot-scope="scope">{{scope.$index+1}}</template>
        </el-table-column>
        <el-table-column prop="fileName" label="音乐名称" min-width="180" align="center"></el-table-column>
        <el-table-column prop="description" label="音乐描述" min-width="300" align="center"></el-table-column>
        <el-table-column label="操作" min-width="330" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleListen(scope.$index,scope.row)">试听</el-button>
            <el-button size="mini" type="warning" @click="handleEdit(scope.$index,scope.row)">修改</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index,scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        layout="total, prev, pager, next"
        :total="totalDataNumber"
        :page-size="pageSize"
        align="center"
        class="fenye"
      ></el-pagination>
    </el-row>
    <!-- 上传音乐的dialog -->
    <el-dialog
      :title="opertion ? '添加音乐' : '修改音乐'"
      :visible.sync="dialogForm"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="音乐名称:" :label-width="formLabelWidth" prop="fileName">
          <el-input v-model.trim="form.fileName" auto-complete="off" placeholder="请输入音乐名称"></el-input>
        </el-form-item>
        <el-form-item label="音乐:" :label-width="formLabelWidth" prop="name">
          <el-row style="height:40px;line-height:40px;">
            <el-col :span="18">
              <el-input
                v-model.trim="form.name"
                :disabled="true"
                auto-complete="off"
                style="width:270px;"
              ></el-input>
            </el-col>
            <el-col :span="6">
              <el-upload
                action="string"
                accept
                :show-file-list="false"
                :before-upload="beforeUpload"
                :http-request="uploadSectionFile"
                ref="music"
                :limit="1"
              >
                <el-button size="small" type="primary" style="margin-left:10px;">点击上传</el-button>
              </el-upload>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="音乐描述:" :label-width="formLabelWidth" prop="description">
          <el-input
            v-model.trim="form.description"
            auto-complete="off"
            type="textarea"
            :rows="3"
            placeholder="请输入音乐描述"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="预览：" :label-width="formLabelWidth">
          <div style="display:flex;flex-wrap:wrap;">
            <div class="video-wrapper" id="zomain">
              <aplayer autoplay :music="musicList" id="audioPlayer"></aplayer>
            </div>
          </div>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click="dialogForm = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="dialogLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="音乐试听"
      :visible.sync="showVideoDialog"
      width="35%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="display:flex;flex-wrap:wrap;">
        <div class="video-wrapper" id="zomain">
         
        </div>
      </div>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click.native="showVideoDialog = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formInline: {
        fileName: ""
      },
      opertion: true, //true为添加  false为修改
      dialogForm: false, //dialog隐藏
      dialogLoading: false, //确定加载按钮
      formLabelWidth: "90px",
      form: {
        fileId: "",
        fileType: 1, //音乐---1   视屏---2  语音---3
        fileName: "",
        filePath: "",
        fileFormat: "mp3/arm",
        description: "",
        name: "",
        id: "",
        duration:"",
      },
      rules: {
        fileName: [
          { required: true, message: "请输入音乐名称", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1到 20 位的字符" }
        ],
        description: [
          { required: false, message: "请输入音乐描述", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1到 50 位的字符" }
        ]
      },
      tableData: [], //表格数据
      tableLoading:false,
      /* 分页的 */
      currentPage: 1, //初始页
      pageNo: 1, //页码
      pageSize: 10, //每页显示的条数
      totalDataNumber: 0, //数据的总数,
      showVideoDialog: false, //播放视频的dialog默认是关闭的
      musicList: {
        title: "",
        artist: "",
        src: '',
        pic: "",
        lrc: "[00:00.00]lrc here\n[00:01.00]aplayer"
      },
      musicSrc:"",
    };
  },
  methods: {
    /* 
      上传
    */
    onUpload() {
      this.dialogForm = true;
      this.opertion = true;
      console.log(this.$refs.form, "------");
      this.$nextTick(() => {
        if (this.$refs.form != undefined || this.$refs.form != null) {
          console.log("___-----");
          this.$refs.form.resetFields(); //移除校验结果并重置字段值
        }
      });
    },

    /* 
      点击查询
    */
    search() {
      console.log("aaaaaaaa");
      if (this.form.fileName == "") {
        this.queryMusicList(this.formInline.fileName, (this.pageNum = 1));
      } else {
        this.queryMusicList(
          this.formInline.fileName,
          (this.pageNum = 1),
          (this.pageSize = 10)
        );
      }
    },

    /* 
      键盘事件 按下键盘回车 查询
    */
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.fileName != null) {
        if (this.form.fileName == "") {
          this.queryMusicList(this.formInline.fileName, (this.pageNum = 1));
        } else {
          this.queryMusicList(
            this.formInline.fileName,
            (this.pageNum = 1),
            (this.pageSize = 10)
          );
        }
      }
    },

    /* 
      刷新
    */
    refresh() {
      this.queryMusicList();
    },

    /* 
      音乐的验证和取值
    */
    beforeUpload(file) {
      console.log(file);
      this.form.name = file.name;
      // let isPNG = false;
      // file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isPNG) {
      //   this.$message.error("上传图片格式不能是 gif 格式");
      // }
      // if (!isLt2M) {
      //   this.$message.error("上传头像图片大小不能超过 2MB");
      // }
      // return isPNG && isLt2M;
      var url = URL.createObjectURL(file);
      var audioElement = new Audio(url);
      var duration;
      var that=this;
      audioElement.addEventListener("loadedmetadata", function (_event) {
        duration = audioElement.duration; //时长为秒，小数，182.36
        console.log(duration,"---fw-ef-re-g")
        that.form.duration = parseInt(duration);
        console.log(that.form.duration);
      });
    },

    /* 
      音乐上传
    */
    uploadSectionFile(param) {
      console.log(param);
      this.form.fileId = "";
      var fileObj = param.file;
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "audio");
        form.append("bucketName", "cmny-oss");
        console.log(form);
        this.$postFormData("opc/file/uploadFile", form).then(res => {
          console.log(res);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.message
            });
            this.form.fileId = res.result; //音乐的id
            this.queryMusicDetail(res.result);
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    },

    /* 
      查询音乐资源
    */
    queryMusicDetail(picId) {
      let id = picId;
      console.log(id);
      if (id) {
        this.form.filePath = "";
        this.$postForm("opc/file/queryAttachmentById/" + id).then(res => {
          console.log(res);
          var path = res.result.path;
          var name = res.result.name;
          this.form.filePath = "http://51cs8.com/" + path + name;
          this.form.name = name;
        });
      }
    },

    /* 
      上传提交数据
    */
    submitForm(datainfo) {
      this.$refs[datainfo].validate(valid => {
        if (valid) {
          let param = new Object();
          param.fileName = this.form.fileName; //文件名  添加和修改都需要提交的
          param.description = this.form.description; //文件描述  添加和修改都需要提交的
          if (this.opertion == true) {
            //新增需要提交的数据
            param.fileId = this.form.fileId; //文件id
            param.fileType = this.form.fileType; //文件类型 音乐---1  视频---2  语音---3
            param.filePath = this.form.filePath; //文件路径
            // param.fileFormat = this.form.fileFormat;//文件的格式
            param.duration = this.form.duration;//时长
          } else {
            //修改需要提交的id
            param.id = this.form.id;
          }
          var url = "";
          url =
            this.opertion == true
              ? "omc/recreationFile/addFile"
              : "omc/recreationFile/editFile";
          console.log(param);
          this.dialogLoading = true;
          this.$postJson(url, param)
            .then(res => {
              console.log(res);
              this.dialogLoading = false;
              this.dialogForm = false;
              this.$refs.form.resetFields(); //移除校验结果并重置字段值
              if (res.code == "200") {
                this.$message({
                  message: res.message,
                  type: "success"
                });
                this.queryMusicList();
              } else {
                this.$message({
                  message: res.message,
                  type: "error"
                });
              }
            })
            .catch(res => {
              this.dialogLoading = false;
            });
        } else {
          console.log("提交失败!");
          return false;
        }
      });
    },

    /* 
      试听
    */
    handleListen(index, row) {
      console.log(index, row);
      this.showVideoDialog = true;
      this.musicList={
        title: row.fileName,
        artist: row.description,
        src: "",
        pic: "",
        lrc: "[00:00.00]lrc here\n[00:01.00]aplayer"
      }
      console.log(this.musicList)
      this.$nextTick(()=>{
        setTimeout(()=>{
          console.log(this.$refs.audio,"this.$refs.audio")
          if(this.$refs.audio){
            this.$refs.audio.src = "";
            //this.$refs.audio.src = "/static/music/388.amr";
            
            //this.$refs.audio.src = row.filePath;
          }
          this.audioUrl=row.filePath;
        },100)
      })
    },

    /* 
      修改
    */
    handleEdit(index, row) {
      console.log(index, row);
      this.dialogForm = true;
      this.opertion = false;
      this.form.id = row.id; //id
      this.form.fileName = row.fileName; //文件名
      this.form.description = row.description; //文件描述
      this.form.name = row.filePath.split("/")[5];
    },

    /* 
      删除
    */
    handleDelete(index, row) {
      console.log(index, row);

      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false
      })
        .then(() => {
          console.log(index, row);
          let id = row.id;
          console.log(id);
          this.$postForm("omc/recreationFile/delectFileById/" + id).then(
            res => {
              console.log(res);
              this.queryMusicList(); //刷新表格数据
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    /* 
      查询音乐列表
    */
    queryMusicList() {
      let params = new Object();
      if (
        this.formInline.fileName != "" ||
        this.formInline.fileName != null ||
        this.formInline.fileName != undefined
      ) {
        params.fileName = this.formInline.fileName;
      }
      params.fileType = this.form.fileType; //默认传1---音乐
      params.pageNo = String(this.pageNo);
      params.pageSize = String(this.pageSize);
      this.tableData = []; //请求之前先清空数据
      this.tableLoading = true;
      console.log(params);
      this.$postJson("omc/recreationFile/queryFileWithPage", params).then(
        res => {
          console.log(res);
          if (res.code == 200) {
            if (res.result.list != null) {
              this.pageSize = res.result.pageSize;
              this.currentPage = res.result.pageNum;
              this.totalDataNumber = res.result.total * 1;
              this.tableData = res.result.list;
            } else {
              this.tableData = [];
              this.pageSize = 10;
              this.currentPage = 1;
              this.totalDataNumber = 0;
            }
          } else {
            this.tableData = [];
            this.pageSize = 10;
            this.currentPage = 1;
            this.totalDataNumber = 0;
          }
          setTimeout(() => {
            this.tableLoading = false;
          }, 500)
        }
      );
    },

    /* 
      初始页currentPage、初始每页数据数pagesize和数据data
    */
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数 
      this.PageSize=val;
      this.queryMusicList();//刷新音乐列表的数据
    },

    /* 
      当前页变化
    */
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.queryMusicList();//刷新音乐列表的数据
    },

    /* 
      表格行的颜色
    */
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #e4f5f8";
      } else {
        return "background-color: #f9f9f9";
      }
    },

    /* 
      表格头部的颜色
    */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#bee1f4;color:#6f7075;font-weight: 500;";
      }
    }
  },
  created() {},
  mounted() {
    this.queryMusicList();
  },
  components: {
  },
};
</script>
<style lang="scss" scoped>
.video-wrapper {
  margin: 0 auto;
  border: 1px solid #ccc;
  width: 85%;
  height: 80px;
}
.daily-video {
  width: 100%;
  height: 100%;
}
.daily-video-source {
  width: 400px;
  height: 100%;
}
</style>